import React, { useEffect, useState, useRef } from "react";
import ShadowLayer from "../../assets/bgScreenbg.webp";
import CustomButton from "./LiveEventCustomButton";
import solidbackgroundimg from "../../assets/solidbackgroundimg.png";
import idmdimg from "../../assets/idmdimg.png";
import { Translate } from "../../components/LanguageChanger";
import { toSentenceCase } from "../../utils/utils";
import Wrapper from "../../components/shared/Wrapper";
import backIcon from "../../assets/back-button.png";
import dotIcon from "../../assets/dotIcon.png";
import { getComingSoon } from "../../services/services";
import { AppContext } from "../../AppContext";
import playIcon from "../../assets/playbuttonicon.png";
import { logFocusEvent } from "../../Analytics/MatomoManager/loger";

let addKeyListener;
let focusedIndex = 1;
let resolution = window.RESOLUTION;
let ReseTfocus1;
let isKeyListenerAdded = false;
let flg = false;
let focusCheckInterval = null;

const LiveEventScreenBGItemScreen = ({
  isError,
  banneritems,
  callBack,
  navigate,
  isDetails,
  isCommingText,
  shouldFocusToScreenBG,
  isLogedIn,
  itemDetails,
  handleErr,
  isLiveEvent,
  getItemDetails,
  isLiveScreen,
  shouldRemindPopup,
  shouldShowAuthModal,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [readMore, setReadMore] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const lastInteractionTime = useRef(Date.now());
  const stateRef = useRef({
    isWatchNowSelected: shouldFocusToScreenBG ? true : false,
    isReadMoreSelected: false,
    isBackButtonSelected: false,
  });

  const [state, setState] = useState({
    isWatchNowSelected: shouldFocusToScreenBG ? true : false,
    isReadMoreSelected: false,
    isBackButtonSelected: false,
  });

  const {
    isWatchNowSelected,
    isReadMoreSelected,
    isBackButtonSelected,
  } = state;

  // Update ref whenever state changes
  useEffect(() => {
  
    stateRef.current = state;
      if(isError){
        const newState = {
          isWatchNowSelected: false,
          isReadMoreSelected: false,
          isBackButtonSelected: true,
        };
        setState(newState);
        focusedIndex = 11;
        return;
      }
  }, [state,isError]);

  window.IS_PAID = itemDetails[0]?.is_paid;

  // Focus failsafe function - only checks for the 3 valid focus states
  const ensureDefaultFocus = () => {
    const currentState = stateRef.current;
    const hasAnyFocus = currentState.isWatchNowSelected || 
                        currentState.isReadMoreSelected || 
                        currentState.isBackButtonSelected;
    
    // If no element is focused and it's been more than 500ms since last interaction
    if (!hasAnyFocus && (Date.now() - lastInteractionTime.current) > 500) {
      console.log('Focus lost detected - restoring to default (Watch Now)');
      focusedIndex = 1;
      const newState = {
        isWatchNowSelected: true,
        isReadMoreSelected: false,
        isBackButtonSelected: false,
      };
      setState(newState);
      stateRef.current = newState;
    }
  };

  // Start focus monitoring when component is active
  const startFocusMonitoring = () => {
    if (focusCheckInterval) {
      clearInterval(focusCheckInterval);
    }
    focusCheckInterval = setInterval(ensureDefaultFocus, 200);
  };

  // Stop focus monitoring
  const stopFocusMonitoring = () => {
    if (focusCheckInterval) {
      clearInterval(focusCheckInterval);
      focusCheckInterval = null;
    }
  };

  addKeyListener = () => {
    if (!isKeyListenerAdded) {
      let tmr = setTimeout(function () {
        clearTimeout(tmr);
        window.removeEventListener("keydown", BGScreenKeyHandler);
        window.addEventListener("keydown", BGScreenKeyHandler);
      }, 500);
      isKeyListenerAdded = true;
      const newState = {
        isWatchNowSelected: true,
        isReadMoreSelected: false,
        isBackButtonSelected: false,
      };
      setState(newState);
      stateRef.current = newState;
      startFocusMonitoring();
    }
  };

  ReseTfocus1 = () => {
    focusedIndex = 1;
  };

  useEffect(() => {
    checkAddedComing(itemDetails);

    if (shouldFocusToScreenBG) {
      setTimeout(function () {
        addKeyListener();
      }, 300);
    } else {
      window.removeEventListener("keydown", BGScreenKeyHandler);
      isKeyListenerAdded = false;
      stopFocusMonitoring();
    }

    // Cleanup on unmount
    return () => {
      stopFocusMonitoring();
    };
  }, [itemDetails,isLiveEvent,isLiveScreen]);

  const truncateText = (text) => {
    if (text?.length > 200) {
      if (!readMore && banneritems[currentIndex]?.playlist_type === "upcoming") {
        return `${text?.slice(0, 200)}`;
      }
      if (readMore) {
        return text?.slice(0, 250);
      } else {
        const words = text?.split(" ");
        if (words?.length > 15) {
          return words?.slice(0, 15)?.join(" ") + "... ";
        }
        return text;
      }
    } else {
      return text;
    }
  };

  let userDetails = JSON.parse(localStorage.getItem("user_details"));
  const subscriptionsArray = userDetails?.user_profiles?.[0]?.subscriptions || [];

  const item = itemDetails?.[0] || {};
  const plans = typeof item.plans === "string" ? item.plans.split(",").map(Number) : typeof item.plans === "number" ? [item.plans] : item.plans;
  const owned = typeof item.owned_by === "string" ? item.owned_by.split(",").map(Number) : typeof item.owned_by === "number" ? [item.owned_by] : [];

  window.PLANSARRAY = plans;
  window.OWNED_BY = owned;
  window.IS_PAID = item.is_paid;

  let subscriptionCheck = itemDetails[0]?.plans === null
    ? hasSingleMatch(owned, subscriptionsArray)
    : arraysEquals(window.PLANSIDS, plans);

  function hasSingleMatch(arr1, arr2) {
    return arr1.some(v => arr2.includes(v));
  }

  function arraysEquals(a, b) {
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }

  const BGScreenKeyHandler = (event, index) => {
    lastInteractionTime.current = Date.now();

    if (index) {
      focusedIndex = index;
    }

    logFocusEvent("LiveEventCustom markup grid ", {
      pressedKey: event.keyCode,
      index,
      focusedIndex,
    });

    if (shouldShowAuthModal) return;

    switch (event.keyCode) {
      case 13: // Enter key
        isKeyListenerAdded = false;

        // Back Button (index 11)
        if (focusedIndex === 11 || isError) {
          handleBack();
          return;
        }

        // Read More (index 9)
        if (focusedIndex === 9) {
          event.preventDefault();
          event.stopPropagation();
          setReadMore((prev) => !prev);
          return;
        }

        // Watch Now (index 1)
        if (focusedIndex === 1) {
          if (isLogedIn) {
            focusedIndex = 1;

            if (itemDetails.length < 1 && getItemDetails) {
              itemDetails = getItemDetails();
            }

            const currentBannerItem = banneritems[currentIndex];
            const isLiveStream = (currentBannerItem.live_date_time > 0 && currentBannerItem.live_end_time === 0 && currentBannerItem.is_live == 1) || currentBannerItem.is_live == 1 || currentBannerItem.still_live == 1;
            const isFreeContent = currentBannerItem.live_date_time === 0 || (currentBannerItem.live_date_time == null && currentBannerItem.live_end_time === 0) || (currentBannerItem.live_end_time == null && currentBannerItem.is_live == 0 && currentBannerItem.is_paid == 0 && currentBannerItem.type == 0);
            const isAudioContent = currentBannerItem.type === 1 || currentBannerItem.media_type === 1;
            const isPaidContent = currentBannerItem.is_paid == 1;
            const isTeaserLaunch = currentBannerItem.isTeaser === 1;
            const adsFreeContent = currentBannerItem.is_paid === 4;
            const normalContent = currentBannerItem && currentBannerItem.length > 0 && currentBannerItem !== undefined && !isAudioContent;

            if (isTeaserLaunch) return;

            shouldFocusToScreenBG = false;
            window.removeEventListener("keydown", BGScreenKeyHandler);

            if (banneritems[currentIndex].live_date_time > 0 && banneritems[currentIndex].live_end_time === 0 && banneritems[currentIndex].is_live !== 1) {
              let tmr = setTimeout(function () {
                clearTimeout(tmr);
                window.removeEventListener("keydown", BGScreenKeyHandler);
                window.addEventListener("keydown", BGScreenKeyHandler);
              }, 500);
              return;
            } else if ((isLiveStream || isFreeContent || currentBannerItem.is_live == 2) && !isPaidContent) {
              navigate("VideoScreen", itemDetails[0] || currentBannerItem);
            } else if (isPaidContent && !isAudioContent) {
              if (subscriptionCheck) {
                navigate("VideoScreen", itemDetails[0]);
              } else {
                handleErr("SUBSCRIBE-MESSAGE");
              }
            } else if (normalContent && !isAudioContent) {
              navigate("VideoScreen", itemDetails[0]);
            } else if (itemDetails && itemDetails.length > 0 && itemDetails[0] !== undefined && !isAudioContent) {
              navigate("VideoScreen", itemDetails[0]);
            } else if (currentBannerItem.file_url && !isAudioContent) {
              navigate("VideoScreen", currentBannerItem);
            } else if (adsFreeContent) {
              navigate("VideoScreen", currentBannerItem);
            } else if (!isAudioContent) {
              navigate("VideoScreen", itemDetails[0]);
            }
          }
        
        }
        break;

      case 38: // Up arrow
      if(isError){
        return ;
      }
        if (isDetails) {
          // From Watch Now (index 1)
          if (focusedIndex === 1) {
            // Check if Read More should be shown
            if (itemDetails[0]?.description[0]?.content.length > 200 || banneritems[currentIndex]?.description[0]?.content.length > 200) {
              const newState = {
                isReadMoreSelected: true,
                isBackButtonSelected: false,
                isWatchNowSelected: false,
              };
              setState(newState);
              stateRef.current = newState;
              focusedIndex = 9;
              return;
            } else {
              // Go directly to Back Button
              const newState = {
                isReadMoreSelected: false,
                isBackButtonSelected: true,
                isWatchNowSelected: false,
              };
              setState(newState);
              stateRef.current = newState;
              focusedIndex = 11;
            }
          }

          // From Read More (index 9) to Back Button (index 11)
          if (focusedIndex === 9) {
            const newState = {
              isReadMoreSelected: false,
              isBackButtonSelected: true,
              isWatchNowSelected: false,
            };
            setState(newState);
            stateRef.current = newState;
            focusedIndex = 11;
            return;
          }
        } else {
          handleBackButton();
        }
        break;

      case 40: // Down arrow
        // From Read More (index 9) to Watch Now (index 1)
        if(isError){
          return;
          
        }
        if (focusedIndex === 9) {
          const newState = {
            isReadMoreSelected: false,
            isWatchNowSelected: true,
            isBackButtonSelected: false,
          };
          setState(newState);
          stateRef.current = newState;
          focusedIndex = 1;
          return;
        }

        // From Back Button (index 11)
        if (focusedIndex === 11) {
          // Check if Read More should be shown
          if (itemDetails[0]?.description[0]?.content.length > 200 || banneritems[currentIndex]?.description[0]?.content.length > 200) {
            const newState = {
              isReadMoreSelected: true,
              isBackButtonSelected: false,
              isWatchNowSelected: false,
            };
            setState(newState);
            stateRef.current = newState;
            focusedIndex = 9;
            return;
          } else {
            // Go directly to Watch Now
            const newState = {
              isReadMoreSelected: false,
              isBackButtonSelected: false,
              isWatchNowSelected: true,
            };
            setState(newState);
            stateRef.current = newState;
            focusedIndex = 1;
            return;
          }
        }
        break;

      case 10009: // Return to home
        if ((isDetails && !flg && !isLiveEvent) || isLiveEvent) {
          const newState = {
            isWatchNowSelected: false,
            isReadMoreSelected: false,
            isBackButtonSelected: false,
          };
          setState(newState);
          stateRef.current = newState;
          setCurrentIndex(0);
          window.removeEventListener("keydown", BGScreenKeyHandler);
          isKeyListenerAdded = false;
          focusedIndex = 1;
          stopFocusMonitoring();
          callBack("HomeScreen");
        }
        break;

      case 461: // Back button
      case 8:   // Backspace
        handleBack();
        break;

      default:
        break;
    }
  };

  function handleBack() {
    if ((isDetails && !flg && !isLiveEvent) || isLiveEvent) {
      const newState = {
        isWatchNowSelected: false,
        isReadMoreSelected: false,
        isBackButtonSelected: false,
      };
      setState(newState);
      stateRef.current = newState;

      setCurrentIndex(0);
      window.removeEventListener("keydown", BGScreenKeyHandler);
      isKeyListenerAdded = false;
      focusedIndex = 1;
      stopFocusMonitoring();
      callBack("HomeScreen");
    }
  }

  const checkAddedComing = async (data) => {
    if (!data[0]?.id) return;

    try {
      const userId = localStorage.getItem("userId");
      const showId = data[0].id;
      const response = await getComingSoon(userId, showId);
      const status = response?.data?.reminder_status || 0;
      window.REMINDER_STATUS = status;
    } catch (error) {
      console.error("Error checking reminder status:", error);
    }
  };

  function formatUnixToDate(unixTimestamp) {
    const date = new Date(unixTimestamp * 1000);
    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12;

    const ordinalSuffix = (n) => {
      if (n > 3 && n < 21) return "th";
      switch (n % 10) {
        case 1: return "st";
        case 2: return "nd";
        case 3: return "rd";
        default: return "th";
      }
    };

    const dayWithSuffix = `${day}${ordinalSuffix(day)}`;
    return `${dayWithSuffix} ${month} ${year}, ${formattedHours}:${formattedMinutes} ${ampm}`;
  }

  function isTimeExpired(unixTimestamp) {
    const currentTime = Math.floor(Date.now() / 1000);
    return currentTime > unixTimestamp;
  }

  const styles = {
    ScreenBGItemContainer: {
      position: "absolute",
      top: "0px",
      left: "0px",
      width: "100vw",
      backgroundImage: `url(${solidbackgroundimg})`,
      height: "100vh",
      overflow: "hidden",
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      position: "absolute",
      top: "0",
      left: "0",
    },
    shadowLayer: {
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      display: "block",
    },
  };

  function handleClick(e, index) {
    lastInteractionTime.current = Date.now();
    const keyEvent = {
      isTrusted: true,
      code: "Enter",
      key: "Enter",
      keyCode: e || 13,
      type: "keydown",
    };
    BGScreenKeyHandler(keyEvent, index);
  }

  const renderContent = (items) =>
    items.map((item, index) => (
      <div key={item.id}>
        {isLiveScreen ? (
          <img
            id={item.id ? item.id : 0}
            src={item.poster_url ? item.poster_url : item.detail_banner}
            alt={item.title ? item.title : ""}
            className="carousel-image"
            style={{
              ...styles.image,
              opacity: index === currentIndex ? 1 : 0,
              transition: "opacity 1s",
            }}
          />
        ) : (
          (item.banner_url || item.detail_banner) && (
            <img
              id={item.id ? item.id : 0}
              src={item.banner_url ? item.banner_url : item.detail_banner}
              alt={item.title ? item.title : ""}
              className="carousel-image"
              style={{
                ...styles.image,
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
              }}
            />
          )
        )}

        <div
          className="carousel-image"
          style={{
            opacity: index === currentIndex ? 1 : 0,
            transition: "opacity 1s",
          }}
        >
          <img src={ShadowLayer} alt="Shadow Layer" style={styles.shadowLayer} />
        </div>

        <div
          className="carousel-image"
          style={{
            opacity: index === currentIndex ? 1 : 0,
            transition: "opacity 1s",
            fontWeight: "bold",
            fontSize: resolution === "FHD" ? "40px" : "27px",
            color: "#F1F1F1",
            position: "absolute",
            width: "100%",
            height: resolution === "FHD" ? "138px" : "92px",
            marginTop: "10rem",
            marginLeft: "7.1rem",
            background: "transparent",
            display: "flex",
            alignItems: "end",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginBottom: "-3rem",
              marginLeft: "0.2rem",
              gap: "0.2rem",
            }}
          >
            {item.banner_icon ? (
              <img
                src={item.banner_icon}
                height={resolution === "FHD" ? "138px" : "92px"}
                alt="Placeholder"
                style={{
                  objectFit: "contain",
                  objectPosition: "left",
                  borderRadius: "0.5rem",
                  height: "12rem",
                  width: "auto",
                  marginBottom: "1rem",
                }}
              />
            ) : (
              <div
                style={{
                  color: "#fff",
                  fontWeight: "bold",
                  fontSize: "3rem",
                  lineHeight: "1",
                  textTransform: "uppercase",
                }}
              >
                {itemDetails[0]?.partner_image_detail_page != null ? (
                  <img style={{ width: "20%" }} src={itemDetails[0]?.partner_image_detail_page} />
                ) : (
                  <img style={{ width: "20%" }} src={itemDetails[0]?.publisher_logo} />
                )}
                {item.title}
              </div>
            )}
            <div style={{ fontSize: "28px", color: "white" }}>
              {item?.language_title && (
                <>
                  {item?.language_title}
                  {(item.agency || item.certificate || (item.rating_json && item.rating_json[0]?.rating)) && (
                    <img
                      src={dotIcon}
                      style={{ width: "9px", height: "9px", marginLeft: "8px", marginRight: "8px", marginBottom: "2px", verticalAlign: "middle" }}
                    />
                  )}
                </>
              )}
              {item.agency && (
                <>
                  {item.agency}
                  {(item.certificate || (item.rating_json && item.rating_json[0]?.rating)) && (
                    <img
                      src={dotIcon}
                      style={{ width: "9px", height: "9px", marginLeft: "8px", marginRight: "8px", marginBottom: "2px", verticalAlign: "middle" }}
                    />
                  )}
                </>
              )}
              {item.certificate && item?.age > 0 && (
                <>
                  {item.certificate}
                  {item.rating_json && item.rating_json[0]?.rating && " . "}
                  {item.age && <span>&nbsp;{item?.age}+</span>}
                </>
              )}
              {item?.rating_json && item?.rating_json?.[0]?.rating && (
                <span style={{ position: "relative", top: "10px" }}>
                  <img src={idmdimg} alt="Rating" />
                  <span style={{ position: "relative", top: "-8px" }}>
                    &nbsp;{item?.rating_json?.[0]?.rating}
                  </span>
                </span>
              )}
            </div>
          </div>
        </div>

        <div
          className="carousel-image"
          style={{
            opacity: 1,
            transition: "opacity 1s",
            color: "rgb(201, 206, 221)",
            fontSize: resolution === "FHD" ? "30px" : "20px",
            position: "absolute",
            width: readMore ? "80%" : "90vh",
            height: "15vh",
            marginTop: "23rem",
            marginLeft: resolution === "FHD" ? "7.5rem" : "5rem",
            background: "transparent",
            overflow: "hidden",
            textOverflow: "ellipsis",
            zIndex: 1,
          }}
        >
          {item?.description && item?.description?.find((item) => item?.language)
            ? item?.description?.find((item) => item.language === localStorage.getItem("AppLanguage"))
              ? truncateText(item?.description?.find((item) => item.language === localStorage.getItem("AppLanguage"))?.content)
              : truncateText(item?.description?.[0]?.content)
            : ""}

          {item?.description?.[0]?.content !== "" &&
            item?.description?.[0]?.content.split(" ").length > 15 &&
            item?.description?.[0]?.content.length > 200 && (
              <span
                tabIndex={0}
                style={{
                  color: focusedIndex === 9 || isHovered ? "#EC008C" : "#fff",
                  display: "inline-block",
                  marginLeft: "10px",
                }}
                onClick={(e) => {
                  if (item?.description[0]?.content.length > 200) setReadMore((prev) => !prev);
                }}
              >
                {!readMore ? <Translate langKey={"view_more"} /> : <Translate langKey={"view_less"} />}
              </span>
            )}
        </div>

        <div
          className="carousel-image"
          style={{
            opacity: index === currentIndex ? 1 : 0,
            transition: "opacity 1s",
            position: "absolute",
            width: "35vw",
            height: "6vh",
            marginTop: "38rem",
            marginLeft: "2.5vw",
            background: "transparent",
          }}
        >
          {item?.genres !== undefined &&
            item?.genres !== null &&
            (() => {
              const genres = item.genres.split(",").slice(0, 3).filter(Boolean);
              return (
                <p
                  style={{
                    textAlign: "center",
                    alignItems: "center",
                    justifyContent: "center",
                    marginLeft: "4.5rem",
                    marginTop: "-8rem",
                    position: "absolute",
                    height: "2vh",
                    borderRadius: "0px",
                    background: "transparent",
                    color: "rgb(137, 150, 185)",
                    display: "inline-flex",
                    fontSize: resolution === "FHD" ? "1.4rem" : "1.2rem",
                  }}
                >
                  {genres.join(" | ")}
                </p>
              );
            })()}
        </div>

        <div
          style={{
            display: isDetails ? "flex" : "none",
            position: "absolute",
            left: "11vh",
            gap: "1rem",
          }}
        >
          <div style={{ display: "flex", gap: "1rem" }}>
            <CustomButton
              isCommingText={
                banneritems[0]?.is_live === 0 &&
                banneritems[0]?.live_date_time > 1
              }
              navigateTo="/login"
              fontSize={resolution === "FHD" ? "26px" : "18px"}
              defaultSelected={isWatchNowSelected}
              height={resolution === "FHD" ? "80px" : "53px"}
              top="50vh"
              onClick={(e) => {
                handleClick(null, 1);
              }}
              className="carousel-image"
              style={{
                opacity: index === currentIndex ? 1 : 0,
                transition: "opacity 1s",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.8rem",
                fontWeight: "bold",
              }}
            >
              <div>
                <img
                  src={playIcon}
                  style={{
                    width: resolution === "FHD" ? "26px" : "18px",
                    height: resolution === "FHD" ? "31px" : "22px",
                    position: "relative",
                    right: "8px",
                    top: "3px",
                    display:
                      (banneritems[0]?.is_live === 0 &&
                        banneritems[0]?.live_date_time &&
                        !isTimeExpired(banneritems[0]?.live_date_time)) ||
                      banneritems[0]?.still_live === 1
                        ? "none"
                        : "inline",
                  }}
                  alt="Play Button"
                />

                <span
                  style={{
                    marginLeft: "3px",
                    position: "relative",
                    top: resolution === "FHD" ? "-3px" : "-4px",
                  }}
                >
                  {banneritems[0]?.type === 1 ||
                  banneritems[0]?.media_type === 1 ? (
                    <Translate langKey={"ListenToWatch"} />
                  ) : banneritems[0]?.is_live === 0 ? (
                    banneritems[0]?.live_date_time ? (
                      isTimeExpired(banneritems[0]?.live_date_time) ? (
                        `Watch since ${formatUnixToDate(
                          banneritems[0]?.live_date_time
                        )}`
                      ) : (
                        `Begins on ${formatUnixToDate(
                          banneritems[0]?.live_date_time
                        )}`
                      )
                    ) : (
                      <Translate langKey={"Watchnow"} />
                    )
                  ) : banneritems[0]?.is_live === 4 ? (
                    <Translate langKey={"Begins_on"} />
                  ) : (
                    <Translate langKey={"Watchnow"} />
                  )}
                </span>
              </div>
            </CustomButton>
          </div>


        </div>
      </div>
    ));

  const handleBackButton = () => {
    lastInteractionTime.current = Date.now();
    let keyEvent = {
      isTrusted: true,
      code: "ArrowDown",
      key: "ArrowDown",
      keyCode: 8,
      type: "keydown",
    };

    BGScreenKeyHandler(keyEvent);
    setTimeout(function () {
      isKeyListenerAdded = false;
      addKeyListener();
    }, 200);
  };

  return (
    <div style={styles.ScreenBGItemContainer}>
      <div
        style={{
          position: "absolute",
          top: "1.6rem",
          zIndex: 100,
        }}
      >
        {(
          <Wrapper
            as="button"
            style={{
              backgroundColor: "transparent",
              border: "none",
              marginLeft: "1rem",
              borderRadius: "1rem",
              aspectRatio: "1/1",
              cursor: "pointer",
              outline: isBackButtonSelected ? "4px solid #EC008C" : "none",
            }}
            onClick={(e) => {
              handleBack();
            }}
          >
            <img src={backIcon} width={50} height={50} />
          </Wrapper>
        )}
      </div>
      {(itemDetails[0]?.isTeaser === 0 || banneritems[0]?.isTeaser === 0) &&
        (itemDetails && itemDetails.length > 0
          ? renderContent(itemDetails)
          : renderContent(banneritems))}
    </div>
  );
};

LiveEventScreenBGItemScreen.setFocus = () => {
  addKeyListener();
};

LiveEventScreenBGItemScreen.ReseTfocus = (focusedIndex) => {
  ReseTfocus1(1);
};

export default LiveEventScreenBGItemScreen;